<template>
  <div>
    <div v-for="(q,index) in questions" :key="`text-${q.id}`">
      <VacancyQuestionRow
        :question="q"
        :index="index"
        :show-preview="showPreview"
        class="draggable-question"
        @updated="updateQuestion"
        @destroy="showDestroyDialog"
      />
    </div>
    <VacancyQuestionDestroyDialog @destroy="destroyQuestion" v-model="destroyDialog" />
  </div>
</template>

<script>
import VacancyQuestionRow from '@/components/Vacancy/VacancyQuestionRow';
import VacancyQuestionDestroyDialog from '@/components/Vacancy/VacancyQuestionDestroyDialog';

export default {
  name: 'VacancyQuestionsLibraryTextList',
  components: { VacancyQuestionDestroyDialog, VacancyQuestionRow },
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    showPreview: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      destroyDialog: false,
      questionToDestroy: null,
      selectedQuestions: [...this.questions],
    };
  },
  methods: {
    showDestroyDialog(question) {
      this.questionToDestroy = question;
      this.destroyDialog = true;
    },
    closeDestroyDialog() {
      this.destroyDialog = false;
    },
    destroyQuestion() {
      this.$emit('destroy', this.questionToDestroy);
      this.closeDestroyDialog();
    },
    updateQuestion(question) {
      this.$emit('update', question);
    },
  },

};
</script>

<style scoped>

</style>
